<template>
    <v-container fluid>

        <v-row justify="center" class="mt-6">
            <v-btn @click="vendor_dialog_title='新增廠商'; new_vendor()" large color="primary" class="ml-3 mt-1" style="height: 46px; font-size: 18px;" >新增廠商</v-btn>
            <v-text-field v-model="search_text" single-line="" class="input_600 ml-3" placeholder="搜尋" append-icon="mdi-magnify" outlined></v-text-field>
            <!-- <v-btn @click="search_data(search_text)" large color="success" class="ml-3 mt-1" style="height: 46px; font-size: 18px;" >搜尋</v-btn> -->
        </v-row>

        <v-row justify="center" class="">
            <v-col cols="12" sm="8" md="6" lg="6" xl="6">
                
                <v-data-table :headers="headers" :items="table_data" :search="search_text" class="elevation-1">
                    <template v-slot:item.id="{ item }">
                        {{table_data.findIndex(items => { return items.name == item.name})+1}}
                    </template>
                    <template v-slot:item.set="{item}">
                        <v-btn color="success" :to="'/vendor_show?vendor_name='+item.name+'&vid='+item.vendor_id">查看</v-btn>
                        <v-btn @click="vendor_dialog_title='修改廠商'; edit_vendor(item)" class="ml-3" color="primary">修改</v-btn>
                        <v-btn @click="open_delete_vendor(item.name)" class="ml-3" color="error">刪除</v-btn>
                    </template>
                </v-data-table>
            </v-col>
        </v-row>
        <v-dialog v-if="vendor_dialog == true" v-model="vendor_dialog" max-width="600px" persistent>
            <v-card style="overflow: hidden;">
                <v-card-title class="headline grey lighten-2">{{vendor_dialog_title}}
                    <v-spacer/>
                    <v-icon @click="vendor_dialog=false; init_vendor_data();">mdi-close</v-icon>
                </v-card-title>
                <v-card-text class="mt-4 pa-6">
                    <v-text-field v-model="vendor_data.name" label="廠商名稱:" :rules="[rules.vendorName]" outlined></v-text-field>
                    <v-text-field v-model="vendor_data.account" label="帳號(請輸入e-mail):" :rules="accountRules" :disabled="edit_status==true" outlined></v-text-field>
                    <v-text-field 
                        v-model="vendor_data.password" 
                        :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'" 
                        :rules="[rules.required, rules.min]"
                        type='password'
                        label="新密碼:" 
                        outlined></v-text-field>
                    <v-text-field 
                        v-model="vendor_data.password2" 
                        label="確認密碼:" 
                        :append-icon="show2 ? 'mdi-eye' : 'mdi-eye-off'" 
                        :rules="[rules.required, rules.min, rules.same]"
                        type="password"                    
                        outlined></v-text-field>
                    <v-radio-group v-if="edit_status==false" v-model="has_bot">
                        <v-radio :value="true" label="有自己的LINE官方帳號"></v-radio>
                        <v-radio :value="false" label="無自己的LINE官方帳號"></v-radio>
                    </v-radio-group>
                    <span v-if="edit_status==false">*備註： 選擇 "無自己的LINE官方帳號" 將會綁定問8的LINE官方帳號, 且之後不得更改</span>
                </v-card-text>
                <v-card-actions class="pl-6 pr-6" justify="center">
                    <v-row justify="center">
                        <v-btn color="success" @click="submit()" block>送出</v-btn>
                    </v-row>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="delete_dialog" max-width="300px" persistent>
            <v-card style="overflow: hidden;">
                <v-card-title class="headline grey lighten-2">確定刪除{{delete_dialog_account}}?
                    <v-spacer/>
                    <v-icon @click="delete_dialog=false">mdi-close</v-icon>
                </v-card-title>
                <v-card-actions>        
                    <v-col>
                        <v-btn @click="delete_dialog = false;" block>取消</v-btn>
                    </v-col>   
                    <v-col>
                        <v-btn color="error" @click="delete_vendor(delete_index); delete_dialog = false;" block>確定</v-btn>       
                    </v-col>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script>
import bus from '../nav/bus'
import { parse } from 'path'

var host_url = process.env.VUE_APP_HOST_URL 
export default {
    data(){
        return {
            type_: "",
            search_text: "",
            page: 0,
            vendor_dialog: false,
            vendor_dialog_title: "",

            show1: true,
            show2: true,

            delete_dialog: false,
            delete_dialog_account: '',
            delete_index: '',

            accountRules: [
                v => !!v || 'E-mail為必填',
                v => /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(v) || 'E-mail must be valid'

            ],
            rules: {
                vendorName: v => !!v || '廠商名稱必填',
                required: value => !!value || '必填',
                min: v => v.length >= 8 || '最少輸入8碼',
                same: v=> v == this.vendor_data.password || '密碼不一致'
            },
            headers: [
                {text: '編號', align: 'center', value: 'id', width: 60, sortable: false},
                {text: '名稱', align: 'center', value: 'name'},
                {text: '操作', align: 'center', value: 'set', width: 300, sortable: false},
            ],
            table_data: [],
            vendor_data: {
                name: '',
                account: '',
                password: '',
                password2: ''
            },
            edit_status: '',

            has_bot: true,
            vendor_id: parseInt(localStorage.getItem('vendor_id')),
            account_type: parseInt(localStorage.getItem('account_type'))
        }
    },
    created(){
        this.get_vendor_data()
    },
    methods: {
        edit_vendor(item){
            this.init_vendor_data()
            this.vendor_dialog = true
            this.edit_status = true
            this.vendor_data.name = item.name
            this.vendor_data.account = item.email
            this.vendor_data.vendor_id = item.vendor_id
            this.vendor_data.account_id = item.account_id
        },
        new_vendor(){
            this.vendor_dialog = true
            this.edit_status = false
        },
        init_vendor_data(){
            this.vendor_data = {
                name: '',
                account: '',
                password: '',
                password2: ''
            }
        },
        // 取得廠商資料
        get_vendor_data(){
            // console.log(host_url+'get_list/?type_id=2')
            axios.get(host_url+'vendor_list/')
            .then(response => {
                var tmp = response.data
                if(tmp.status == true){
                    this.table_data = tmp.data;
                }
            })
            .catch((error) =>{
                // this.$ga.event('liff_manage', 'getliffevent', 'Error')
                console.log(error);
            });
        },
        // 新增/編輯廠商
        submit(){
            if(this.edit_status == false){
                let data = this.vendor_data
                if(data.name == ''){ bus.$emit('alert', {msg: "廠商名稱不能空白", title: "錯誤提示",　check: "我知道了"}); return; }
                if(this.checkEmail(data.account) == false){ bus.$emit('alert', {msg: "帳號不能空白, 且請輸入正確的email", title: "錯誤提示",　check: "我知道了"}); return; }
                if(data.password != ''){ 
                    if(this.checkPassword(data.password) == false){
                        bus.$emit('alert', {msg: "密碼不能為空白、小於8碼、密碼不一致", title: "錯誤提示",　check: "我知道了"}); return; 
                    }                    
                }
                if(data.password != ''){ 
                    if(this.checkPassword(data.password2)== false){
                        bus.$emit('alert', {msg: "確認密碼不能為空白、小於8碼、密碼不一致", title: "錯誤提示",　check: "我知道了"}); return; 
                    }                    
                }
                let type_ = 'vendor'
                bus.$emit('update', {msg: '新增中...'})
                axios.post(host_url+'api/account/', {'data': data, 'type': type_, 'vendor_id': localStorage.getItem('vendor_id'), 'has_bot': this.has_bot })
                .then(response => {
                    bus.$emit('close_update')
                    var tmp = response.data
                    if(tmp.status == true){
                        this.get_vendor_data()
                        bus.$emit('alert', {msg: tmp.msg, title: "提示",　check: "我知道了"})
                        this.init_vendor_data()
                        this.vendor_dialog = false
                    }
                    else{
                        bus.$emit('alert', {msg: tmp.msg, title: "錯誤提示",　check: "我知道了"})
                    }
                })
                .catch((error) =>{
                    // this.$ga.event('liff_manage', 'getliffevent', 'Error')
                    console.log(error);
                });
            }
            else{
                let type_ = 'vendor'
                let data = this.vendor_data
                if(data.name == ''){ bus.$emit('alert', {msg: "廠商名稱不能空白", title: "錯誤提示",　check: "我知道了"}); return; }
                if(this.checkEmail(data.account) == false){ bus.$emit('alert', {msg: "帳號不能空白, 且請輸入正確的email", title: "錯誤提示",　check: "我知道了"}); return; }
                if(data.password != ''){ 
                    if(this.checkPassword(data.password) == false){
                        bus.$emit('alert', {msg: "密碼不能為空白、小於8碼、密碼不一致", title: "錯誤提示",　check: "我知道了"}); return; 
                    }                    
                }
                if(data.password != ''){ 
                    if(this.checkPassword(data.password2)== false){
                        bus.$emit('alert', {msg: "確認密碼不能為空白、小於8碼、密碼不一致", title: "錯誤提示",　check: "我知道了"}); return; 
                    }                    
                }
                bus.$emit('update', {msg: '修改中...'})
                axios.post(host_url+'update_vendor/', {'data': data, 'type': type_, 'vendor_id': localStorage.getItem('vendor_id') })
                .then(response => {
                    bus.$emit('close_update')
                    var tmp = response.data
                    if(tmp.status == true){
                        this.table_data = tmp.data
                        this.vendor_dialog = false
                        // console.log('success')
                        if(data.password != ''){
                            bus.$emit('alert', {msg: "修改成功!請至信箱確認帳密！", title: "成功提示",　check: "我知道了"})
                        }
                        else{
                            bus.$emit('alert', {msg: "修改成功!", title: "成功提示",　check: "我知道了"})
                        }
                        
                        
                    }
                    else{
                        bus.$emit('alert', {msg: tmp.msg, title: "錯誤提示",　check: "我知道了"})
                    }

                })
                .catch((error) =>{
                    // this.$ga.event('liff_manage', 'getliffevent', 'Error')
                    console.log(error);
                });
            }
        },
        // 確認信箱格式
        checkEmail(val){
            const regexp = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            if (regexp.test(val)){ return true; }
            else { return false; }
        },
        // 確認密碼格式
        checkPassword(val){
            if(val == ''){ return false}
            if(val.length < 8){ return false}
            if(val != this.vendor_data.password){ return false}
        },
        // 開啟刪除提醒
        open_delete_vendor(name){
            this.delete_dialog_account = name;
            this.delete_dialog = true;
            this.delete_index = this.table_data.findIndex(item => {
                return item.name == name;
            });
        },
        // 刪除廠商
        delete_vendor(idx){
            // console.log(this.table_data[idx])
            let data = this.table_data[idx]
            axios.post(host_url+'delete_vendor/', {'data': data})
            .then(response => {
                var tmp = response.data
                if(tmp.status == true){
                    this.get_vendor_data()
                    // console.log('success')
                }
                else{
                    bus.$emit('alert', {msg: tmp.msg, title: "錯誤提示",　check: "我知道了"})
                }

            })
            .catch((error) =>{
                // this.$ga.event('liff_manage', 'getliffevent', 'Error')
                console.log(error);
            });
            this.table_data.splice(idx, 1);
        },
    }
}
</script>

<style lang="scss" scoped>

::v-deep .input_200{
    max-width: 200px;
}

::v-deep .input_600{
    max-width: 600px;
}


</style>